"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    p {
        margin-bottom: 2em;
        &.centered {
            text-align: center;
        }
    }
    .btn {
        @media screen and ${constants_1.Device.mobileL} {
            width: 100% !important;
            margin-bottom: 2em;
        }
    }

    h1 {
        margin-top: 0;
        padding: 2em 0;
        font-family: BurbankBigCondensed-Black, sans-serif;

        font-size: 3em;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        color: $text-color;
        text-align: center;
        text-shadow: 0 3px 5px rgba($invert-text-color, 0.8);
        @media screen and ${constants_1.Device.mobileL} {
            padding: 1em 0;
        }
    }
    .siteBlock {
        margin: 0 auto;
        padding: 40px 60px 60px;
        border: 1px solid $siteBlockBorder;
        width: 700px;
        background-color: $siteBlockBg;
        background-size: cover;
        box-shadow: 0px 9px 27px 0px #666;
        .subtitle {
            display: block;
            margin: 0 0 28px;
            height: 43px;
            color: #1e1e1e;
            font-family: OpenSans, sans-serif;
            font-size: 13px;
            line-height: 43px;
            font-weight: 600;
            letter-spacing: 0.59px;
            text-transform: uppercase;
            text-align: left;
        }
        .errorMessage {
            color: $errorMessageText;
            font-family: OpenSans, sans-serif;
            font-size: 14px;
            @media screen and ${constants_1.Device.mobileL} {
                font-size: 12px;
            }
        }
        p {
            color: #bfbfbf;
            font-family: OpenSans, sans-serif;
            font-size: 12px;
            line-height: 2;
            &.centered {
                text-align: center;
            }
        }
        @media screen and ${constants_1.Device.mobileL} {
            width: 100%;
            padding: 1.2em;
        }
    }
    .squareButton {
        @media screen and ${constants_1.Device.mobileL} {
            width: 100% !important;
        }
    }
    .buttonContainer {
        text-align: center;
        .squareButton:first-child {
            margin-right: 50px;
            @media screen and ${constants_1.Device.mobileL} {
                margin-right: 0;
                margin-bottom: 28px;
            }
        }
    }
`;
//# sourceMappingURL=InviteContainer.js.map